module.exports = __webpack_public_path__ + "static/media/Mushroom.4d30186a.png";